<template>
    <div class="nav_bar">
        <div class="logo_info">
            <img :src="logo || require('@/assets/logo.png')" class="logo" @click="jumpPath(0)"/>
            <div class="font26">{{siteName}}</div>
        </div>
        <div class="nav_right">
            <div class="tag_box">
                <div class="tag_item" :class="{active:navIndex==0}" @click="jumpPath(0)">首页</div>
                <div class="tag_item" :class="{active:navIndex==1}" @click="jumpPath(1)">联系我们</div>
            </div>
            <div class="user_box no_login">
                <img v-if="isLogin" :src="userHead" class="img_avatar" @click="showTag"/>
                <img v-else src="@/assets/default_avatar.png" class="img_avatar"/>
                <span v-if="isLogin" class="user_text point" @click="showTag">您好，{{ userName }}</span>
                <span v-else class="ml_16 blue_text font16 point" @click="handleLogin">登录</span>
                <img src="@/assets/icon_down.png" class="icon_down" :class="{right:popupShow}" @click="showTag"
                     v-if="isLogin"/>
                <div class="popup" v-if="popupShow">
                    <div class="" @click="myStudy">我的学习</div>
                    <div class="" @click="userCenter">个人中心</div>
                    <div class="" @click="loginOut">退出登录</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";

export default {
    name: 'navbar',
    props: {
        logo: String,
        siteName: String
    },
    data() {
        return {
            popupShow: false,
            navIndex: 0
        }
    },
    computed: {
        isLogin() {
            let token = Cookies.get('token') || ''
            return token.length > 0
        },

        userName() {
            return Cookies.get('name') || ''
        },

        userHead() {
            let head = Cookies.get('head')
            return head !== 'null' ? head : require('@/assets/img_avatar.png')
        }
    },
    methods: {
        showTag() {
            this.popupShow = !this.popupShow
        },
        jumpPath(type) {
            this.navIndex = type
            let pathUrl = type == 0 ? 'notice' : 'contactUsInfo'
            this.$router.push({name: pathUrl})
        },
        handleLogin() {
            this.$router.push({name: 'login'})
        },
        myStudy() {
            this.$router.replace('/homeCenter/resultsQuery').catch(() => {
                // 这里可以处理 NavigationDuplicated 错误或者什么都不做
            });
            this.showTag()
        },
        userCenter() {
            this.$router.replace('/homeCenter/userSetting').catch(() => {
                // 这里可以处理 NavigationDuplicated 错误或者什么都不做
            });
            this.showTag()
        },
        loginOut() {
            this.clearCookie()
            this.$router.replace({name: 'login'})
            window.location.reload()
        },
        clearCookie() {
            Cookies.remove('token');
            Cookies.remove('id');
            Cookies.remove("phone");
            Cookies.remove('name');
            Cookies.remove('head');
        },
    }
}
</script>
<style lang="scss" scoped>
.nav_bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 92px;
    padding: 0 360px;
    background-color: #DBEAFB;

    .logo_info {
        display: flex;
        align-items: center;
        font-weight: 600;
        color: #4A96EC;
        font-size: 26px;
    }

    .logo {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;
        cursor: pointer;
    }

    .nav_right {
        display: flex;
        align-items: center;
    }

    .tag_box {
        display: flex;
        align-items: center;

        .tag_item {
            margin-right: 26px;
            font-size: 18px;
            cursor: pointer;

            &.active {
                color: #4A96EC;
            }
        }
    }

    .user_box {
        display: flex;
        align-items: center;
        padding: 0 6px;
        height: 52px;
        border-radius: 26px;
        background-color: #fff;
        margin-left: 110px;
        position: relative;
        min-width: 130px;

        &.no_login {
            background-color: #E8F1FF;
        }

        .img_avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            cursor: pointer;
        }

        .user_text {
            font-size: 16px;
            margin: 0 8px;
        }

        .icon_down {
            width: 8px;
            height: 8px;
            cursor: pointer;

            &.right {
                transform: rotate(180deg);
            }
        }

        .popup {
            position: absolute;
            bottom: -128px;
            left: 40px;
            border-radius: 6px;
            // padding: 0 28px;
            margin: 0 auto;
            width: 100px;
            background-color: #fff;
            display: flex;
            align-items: center;
            flex-direction: column;
            z-index: 100;

            > div {
                padding: 12px 0;
                border-bottom: 1px solid #EEEEEE;
                cursor: pointer;
                font-size: 14px;

                &:last-child {
                    border-bottom: 0;
                }
            }
        }
    }
}
</style>
